import { Switch, Tooltip } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import { useTranslation } from "next-i18next";
import { useState } from "react";
import { EditProps } from "./util";

const SwitchProp = ({
  object,
  prop,
  mutate,
  label,
  tooltip,
  disabled,
  onChange: onChangeProp,
}: EditProps) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(object[prop] === true);
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // console.log("onChange :", e.target.checked);
    setValue(e.target.checked);
    const dto: any = {
      _id: object._id,
    };
    const checked = e.target.checked;
    dto[prop] = checked;
    if (onChangeProp) onChangeProp(checked);
    mutate(dto, {
      onSuccess: () =>
        showNotification({
          message: t("Saved"),
          autoClose: true,
          color: "success",
        }),
    });
  };
  return (
    <>
      <Tooltip label={tooltip}>
        <Switch
          label={label}
          checked={value}
          onChange={onChange}
          disabled={disabled}
        />
      </Tooltip>
    </>
  );
};
export default SwitchProp;
